import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    expertMode: false,
    drawer: null,
    token: localStorage.getItem('token') || '',
    title: '',
  },
  getters: {
    expertMode: (state) => state.expertMode,
    drawer: (state) => state.drawer,
    isAuthenticated: (state) => !!state.token,
    title: (state) => state.title,
  },
  actions: {
    setExpertMode({ dispatch }, mode) {
      if (mode) dispatch('enableExpertMode');
      else dispatch('disableExpertMode');
    },
    enableExpertMode({ commit }) {
      commit('ENABLE_EXPERT_MODE');
    },
    disableExpertMode({ commit }) {
      commit('DISABLE_EXPERT_MODE');
    },
    toggleDrawer({ commit }) {
      commit('TOGGLE_DRAWER');
    },
    setDrawer({ commit }, newDrawerState) {
      commit('SET_DRAWER_STATE', newDrawerState);
    },
    refreshToken({ commit }) {
      commit('REFRESH_TOKEN');
    },
    setTitle({ commit }, newTitle) {
      commit('SET_TITLE', newTitle);
    },
  },
  mutations: {
    ENABLE_EXPERT_MODE: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.expertMode = true;
    },
    DISABLE_EXPERT_MODE: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.expertMode = false;
    },
    TOGGLE_DRAWER: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.drawer = !state.drawer;
    },
    SET_DRAWER_STATE: (state, newDrawerState) => {
      // eslint-disable-next-line no-param-reassign
      state.drawer = newDrawerState;
    },
    REFRESH_TOKEN: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.token = localStorage.getItem('token') || '';
    },
    SET_TITLE: (state, newTitle) => {
      // eslint-disable-next-line no-param-reassign
      state.title = newTitle;
    },
  },
});
